import { css, SerializedStyles } from '@emotion/core'

import { BorderRadius } from '../../../enums/borderRadius'
import { FontSize } from '../../../enums/fontSize'
import { FontWeight } from '../../../enums/fontWeight'
import { LineHeight } from '../../../enums/lineHeight'
import { Spacing } from '../../../enums/spacing'
import { sizeToDimension } from '../constants/sizeToDimension'
import { Size } from '../types'
import { getWidthProperty } from './getWidthProperty'

export const getSizeStyle = (size: Size, forceSquareRatio?: boolean, fullWidth?: boolean): SerializedStyles =>
  ({
    sm: css`
      ${getWidthProperty(forceSquareRatio, fullWidth)}: 32px;
      height: ${sizeToDimension[size]}px;
      border-radius: ${BorderRadius.RFull};
      padding: ${Spacing.S4} ${Spacing.S12};
      font-size: ${FontSize.TextBodyMD};
      font-weight: ${FontWeight.SemiBold};
      line-height: ${LineHeight.TextBodyMD};
    `,
    md: css`
      ${getWidthProperty(forceSquareRatio, fullWidth)}: 40px;
      height: ${sizeToDimension[size]}px;
      border-radius: ${BorderRadius.RFull};
      padding: ${Spacing.S10} ${Spacing.S12};
      font-size: ${FontSize.TextBodyMD};
      font-weight: ${FontWeight.SemiBold};
      line-height: ${LineHeight.TextBodyMD};
    `,
    lg: css`
      ${getWidthProperty(forceSquareRatio, fullWidth)}: 48px;
      height: ${sizeToDimension[size]}px;
      border-radius: ${BorderRadius.RFull};
      padding: ${Spacing.S12};
      font-size: ${FontSize.TextBodyLG};
      font-weight: ${FontWeight.SemiBold};
      line-height: ${LineHeight.TextBodyLG};
    `,
  })[size]
